import axios from 'axios';

// PHP backend API base URL
const getBaseURL = () => {
  // Production API URL for fuelentry.in
  if (window.location.hostname === 'fuelentry.in' || window.location.hostname === 'www.fuelentry.in') {
    return '/api'; // Relative path for production
  }
  // Development fallback
  return 'http://localhost/EmployeeUpdateManager/php-backend/api';
};

// Create axios instance
const api = axios.create({
  baseURL: getBaseURL(),
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth endpoints
export const login = (email, password) => api.post('/auth/login', { email, password });
export const register = (name, email, password, role) => api.post('/auth/register', { name, email, password, role });

// Employee endpoints
export const recordLogin = () => api.post('/employees/login');
export const recordLogout = () => api.post('/employees/logout');
export const getAttendance = (employeeId, startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  
  return api.get(`/employees/${employeeId}/attendance`, { params });
};

// Fuel endpoints
export const recordFuelSale = (fuelData) => api.post('/fuel/record', fuelData);
export const getFuelRecords = (params) => {
  // params can be a date string for backward compatibility or an object with date/month
  const queryParams = {};
  if (typeof params === 'string') {
    // Backward compatibility: treat as date
    queryParams.date = params;
  } else if (params && typeof params === 'object') {
    // New format: can have date, month, or both
    if (params.date) queryParams.date = params.date;
    if (params.month) {
      // Validate month format (should be YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(params.month)) {
        queryParams.month = params.month;
      }
    }
  }
  return api.get('/fuel', { params: queryParams });
};
export const getEmployeeFuelRecords = (employeeId, params) => {
  // params can be a date string for backward compatibility or an object with date/month
  const queryParams = {};
  if (typeof params === 'string') {
    // Backward compatibility: treat as date
    queryParams.date = params;
  } else if (params && typeof params === 'object') {
    // New format: can have date, month, or both
    if (params.date) queryParams.date = params.date;
    if (params.month) queryParams.month = params.month;
  }
  return api.get(`/fuel/employee/${employeeId}`, { params: queryParams });
};
export const getDailySummary = () => api.get('/fuel/summary/daily');
export const getTeamSales = () => api.get('/fuel/team-sales');

// Metrics
export const getTodayMetrics = () => api.get('/metrics/today');

// Fuel Rates endpoints
export const getFuelRates = () => api.get('/fuel-rates');
export const getFuelRateByType = (fuelType) => api.get(`/fuel-rates/${fuelType}`);
export const updateFuelRate = (fuelType, rate) => api.put(`/fuel-rates/${fuelType}`, { rate });
export const getAllFuelRates = () => api.get('/fuel-rates/all/rates');
export const getFuelRateHistory = (fuelType) => api.get(`/fuel-rates/${fuelType}/history`);
export const getAllFuelRateHistory = () => api.get('/fuel-rates/history/all');
export const getFuelRateStatistics = () => api.get('/fuel-rates/history/statistics');

// Admin endpoints
export const getEmployees = () => api.get('/employees');
export const getEmployeeById = (id) => api.get(`/employees/${id}`);
export const resetEmployeePassword = (id, newPassword) => api.put(`/employees/${id}/reset-password`, { newPassword });
export const getAllEmployees = () => api.get('/employees');

export default api;